import CategoriaProductoService from 'src/modules/categoriaProducto/categoriaProductoService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'CATEGORIAPRODUCTO_FORM';

const categoriaProductoFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaProductoFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await CategoriaProductoService.find(id);
      }

      dispatch({
        type: categoriaProductoFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: categoriaProductoFormActions.INIT_ERROR,
      });

      getHistory().push('/categoria-producto');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaProductoFormActions.CREATE_STARTED,
      });

      await CategoriaProductoService.create(values);

      dispatch({
        type: categoriaProductoFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.categoriaProducto.create.success'),
      );

      getHistory().push('/categoria-producto');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: categoriaProductoFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: categoriaProductoFormActions.UPDATE_STARTED,
      });

      await CategoriaProductoService.update(id, values);

      dispatch({
        type: categoriaProductoFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.categoriaProducto.update.success'),
      );

      getHistory().push('/categoria-producto');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: categoriaProductoFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default categoriaProductoFormActions;
